import type { StageDefinition } from "../../content/stages.js";

export function bringInDividerIndex(stages: Pick<StageDefinition, "allowBringIn">[]): number | null {
  for (let i = 1; i < stages.length; i += 1) {
    if (!stages[i - 1].allowBringIn && stages[i].allowBringIn) return i;
  }
  return null;
}
